
import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { FaqList } from "@/components/knowledge-hub/FaqList";
import { FaqSearch } from "@/components/knowledge-hub/FaqSearch";
import { useIsMobile } from "@/hooks/use-mobile";
import ChatOption from "@/components/ChatOption";

const Faqs = () => {
  const [selectedFaqId, setSelectedFaqId] = useState<string | undefined>();
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F1F0FB] to-white">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto mb-12 text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-[#4A607B] mb-6 relative inline-block">
            Frequently Asked Questions
            <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-1/4 h-1 bg-corporate-secondary-100 rounded-full"></div>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto mt-8">
            Find answers to the most common questions about cryptocurrency trading and our platform.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <FaqSearch onSelectFaq={setSelectedFaqId} />

          <div className="bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 p-0.5 rounded-2xl shadow-lg">
            <div className="bg-white p-6 md:p-8 rounded-2xl">
              <FaqList selectedFaqId={selectedFaqId} />
            </div>
          </div>
        </motion.div>
      </div>
      {/* Only show ChatOption on desktop */}
      {!isMobile && (
        <ChatOption />
      )}
      <Footer />
    </div>
  );
};

export default Faqs;
